import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation",
  "use": "navigation-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"navigation\">\n<path d=\"M13,22C13,22,12.9,22,13,22c-0.5,0-0.9-0.3-1-0.8l-1.9-7.4L2.8,12C2.3,11.9,2,11.5,2,11.1s0.2-0.8,0.6-1l19-9\n\tC22,0.9,22.4,1,22.7,1.3C23,1.6,23.1,2,22.9,2.4l-9,19C13.7,21.8,13.4,22,13,22z M6,10.7l5.3,1.3c0.4,0.1,0.6,0.4,0.7,0.7l1.3,5.3\n\tl6.6-13.9L6,10.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol